var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        title: _vm.$t("CargoMsg.Cargo_UpdateReceivedAmount"),
        "close-on-click-modal": false,
        visible: _vm.innerVisible,
        width: "330px"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        },
        close: _vm.cancel
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "app-main-inner-row",
          staticStyle: { "padding-bottom": "10px" }
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                inline: true,
                "label-width": "70px",
                "label-position": "left"
              },
              nativeOn: {
                submit: function($event) {
                  $event.preventDefault()
                }
              }
            },
            [
              _c(
                "div",
                { staticStyle: { "margin-top": "10px" } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("CargoMsg.Cargo_ReceiptAmount") }
                    },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "120px" },
                        attrs: {
                          "controls-position": "right",
                          precision: 2,
                          step: 1,
                          max: 999999999999
                        },
                        model: {
                          value: _vm.receivedAmount,
                          callback: function($$v) {
                            _vm.receivedAmount = $$v
                          },
                          expression: "receivedAmount"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "mini" },
              on: { click: _vm.confirm }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
          ),
          _c(
            "el-button",
            { attrs: { size: "mini" }, on: { click: _vm.cancel } },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }